
import { ActivityEntityName, Entity } from '../../../../entities';
import { MergeDataset, MergeSource } from '../../decorators';
import { ActivityMergeSchema, ActivityMergeData, AttachmentMergeSchema, AttachmentMergeData } from '../data/activity.merge.data';
import { BasicSiteMergeSchema, BasicSiteMergeData } from '../data/basic.site.merge.data';
import { CompanyMergeSchema, CompanyMergeData } from '../data/company.merge.data';
import { InvoiceAccountMergeSchema, InvoiceAccountMergeData } from '../data/invoice.account.merge.data';
import { InvoiceActivitiesMergeDataSchema, InvoiceActivitiesMergeData, InvoiceAttachmentsMergeDataSchema, InvoiceAttachmentsMergeData } from '../data/invoice.attachments.merge.data';
import { InvoiceMergeSchema, InvoiceMergeData } from '../data/invoice.merge.data';
import { InvoiceMergeDataset } from './invoice.merge.dataset';

@MergeDataset({
    entity: ActivityEntityName.Bill,
    dependsOn: [
        ActivityEntityName.Job,
        ActivityEntityName.WorkOrder,
    ]
})
export class BillMergeDataset {
    @MergeSource({
        schema: InvoiceMergeSchema,
        ignoreFields: ['jobLinesBillable']
    })
    invoice: InvoiceMergeData;

    @MergeSource({
        schema: CompanyMergeSchema
    })
    invoiceCompany: CompanyMergeData;

    @MergeSource({
        schema: InvoiceAccountMergeSchema
    })
    invoiceAccount: InvoiceAccountMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    invoiceAccountSite: BasicSiteMergeData;

    @MergeSource({
        schema: BasicSiteMergeSchema
    })
    invoiceJobSite: BasicSiteMergeData;

    @MergeSource({
        schema: ActivityMergeSchema,
        displayName: "Activities (Deprecated)",
        ignoreFields: ['attachments']
    })
    activities: ActivityMergeData[];

    @MergeSource({
        schema: AttachmentMergeSchema,
        displayName: "Media Attachments (Deprecated)",

    })
    mediaAttachments: AttachmentMergeData[];

    @MergeSource({
        schema: AttachmentMergeSchema,
        displayName: "File Attachments (Deprecated)"
    })
    fileAttachments: AttachmentMergeData[];

    @MergeSource({
        schema: InvoiceActivitiesMergeDataSchema,
        ignoreCustomFields: true,
    })
    invoiceActivities: InvoiceActivitiesMergeData;

    @MergeSource({
        schema: InvoiceAttachmentsMergeDataSchema,
        ignoreCustomFields: true,
    })
    invoiceAttachment: InvoiceAttachmentsMergeData;

    public theme: Entity;
}


